export const cutText = (text: string, maxLength: number, separator = ' ') =>
    text.length <= maxLength ? text : text.substring(0, text.lastIndexOf(separator, maxLength));
